import { Link } from "react-router-dom";
import { LineReveal } from "../components/RevealText";

export const PROJECTS = [
  {
    slug: "good-samaritan-hospital",
    name: "Good Samaritan Hospital",
    location: "West Islip, NY",
    cover: "/assets/proj_goodsam.webp",
    gallery: [
      "/assets/proj_goodsam.webp",
      "/assets/proj_asp.webp",
      "/assets/proj_mart.jpg",
    ],
    summary:
      "297,000 Sq Ft Addition. 16 Operating Rooms. 9 Air Handlers with Heat Recovery. 10 Pumps. 2 Heat Exchangers. 335 VAV Boxes.",
  },
  {
    slug: "nsuh-advanced-surgical-pavilion",
    name: "NSUH Advanced Surgical Pavilion",
    location: "Manhasset, NY",
    cover: "/assets/proj_asp.webp",
    gallery: [
      "/assets/proj_asp.webp",
      "/assets/proj_nyu_manhasset.webp",
      "/assets/proj_goodsam.webp",
    ],
    summary:
      "290,000 Sq Ft. Addition. 18 Operating Rooms. 4 100-Ton Air Handlers with Heat Recovery. 3 Cooling Towers. 2 Chillers. Supply / Exhaust Boxes with Air Tracking.",
  },
  {
    slug: "stony-brook-mart",
    name: "Stony Brook MART",
    location: "Stony Brook, NY",
    cover: "/assets/proj_mart.jpg",
    gallery: [
      "/assets/proj_mart.jpg",
      "/assets/proj_asp.webp",
      "/assets/proj_dealertrack.jpg",
    ],
    summary:
      "470,000 Sq Ft Addition. Imaging & Research Facility + Children's Hospital. 17 Air Handlers. 2 Heat Recovery Units. 2 Air-Cooled Chillers.",
  },
  {
    slug: "ronkonkoma-hub",
    name: "Ronkonkoma Hub",
    location: "Ronkonkoma, NY",
    cover: "/assets/proj_ronkonkoma_hub.png",
    gallery: [
      "/assets/proj_ronkonkoma_hub.png",
      "/assets/proj_mart.jpg",
      "/assets/proj_goodsam.webp",
    ],
    summary:
      "Multi-level, 500-space parking garage. 489 residential units. 19,000 sq ft of retail.",
  },
  {
    slug: "nyu-langone-manhasset",
    name: "NYU Langone Health — Manhasset",
    location: "Manhasset, NY",
    cover: "/assets/proj_nyu_manhasset.webp",
    gallery: [
      "/assets/proj_nyu_manhasset.webp",
      "/assets/proj_asp.webp",
      "/assets/proj_goodsam.webp",
    ],
    summary:
      "165,000 Sq Ft Renovation. 8 Operating Rooms. Imaging.",
  },
  {
    slug: "dealertrack-hq",
    name: "Dealertrack Corporate HQ",
    location: "New Hyde Park, NY",
    cover: "/assets/proj_dealertrack.jpg",
    gallery: [
      "/assets/proj_dealertrack.jpg",
      "/assets/proj_ronkonkoma_hub.png",
      "/assets/proj_mart.jpg",
    ],
    summary:
      "233,000 Sq Ft. New Construction Building consisting of 2 Cooling Towers. 22 Water-Cooled Air Handlers. 4 Boilers. Fan-Powered Boxes on each floor.",
  },
];

export default function Projects() {
  return (
    <main data-testid="projects-page" className="bg-black text-white pt-24">
      <section className="border-b border-white/10 px-4 md:px-6 py-12 md:py-16">
        <h1 className="font-display font-bold text-6xl md:text-8xl leading-[0.9] uppercase">
          <LineReveal delay={0.15}>Projects</LineReveal>
        </h1>
        <p
          data-testid="projects-subheading"
          className="mt-4 md:mt-6 font-display text-2xl md:text-3xl text-white/70"
        >
          Over 2,000 completed
        </p>
      </section>

      <section
        data-testid="projects-grid"
        className="border-b border-white/10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-0"
      >
        {PROJECTS.map((p, i) => (
          <Link
            key={p.slug}
            to={`/projects/${p.slug}`}
            data-testid={`project-card-${p.slug}`}
            className="group relative block aspect-[4/5] overflow-hidden border-b border-l border-white/10 [&:nth-child(3n+1)]:border-l-0 first:border-t-0"
          >
            <img
              src={p.cover}
              alt={p.name}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60 mb-2">
                {p.location}
              </p>
              <h3 className="font-display text-3xl md:text-4xl leading-tight transition-transform duration-500 group-hover:translate-x-1">
                {p.name}
              </h3>
              <span className="mt-3 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70 group-hover:text-white transition-colors">
                View project →
              </span>
            </div>
          </Link>
        ))}
      </section>

      {/* Additional jobs (text-only) */}
      <section
        data-testid="projects-list-more"
        className="border-b border-white/10 px-4 md:px-6 py-10 md:py-14"
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/50 mb-6">
          Additional Projects
        </p>
        <ul className="divide-y divide-white/10 border-t border-white/10">
          {["Yaphank Jail", "DOS District 1/2/5 Garage NYC", "NYU Riverhead", "NYU Westhampton", "NYU Patchogue"].map((name) => (
            <li
              key={name}
              data-testid={`project-list-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="py-5 md:py-6 font-display text-2xl md:text-3xl text-white/85"
            >
              {name}
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}
